/**
 * Lenders。Management 页和 Rates Add lenders 弹窗共用同一组件。
 * 打开 Management 页打 STATSIG.COMMON.VIEW，value=mgmt_lenders。
 *
 * INSERT / UPDATE / DELETE：两边都打，行为跟原来 Rates 一样。
 * Add lender 勾选后 Next 只进列表，不打点；第一次 Save 落库才是 INSERT；
 * 已有 lender Save 是 UPDATE；删除是 DELETE。
 * value 与 metadata.lender_id 相同，如 lender_id-34。
 *
 * 只在 Management 页打：PAGE_VIEW、ADD_LENDER_BUTTON、PROMOTION_*、ADJUSTMENT_*、REQUEST。
 *
 * 已不算：搜索、表格/卡片切换、点编辑图标、弹窗里加 condition、
 * 关费加减行、Upgrade now、Copy adjustment（无入口）、EditLenderModal。
 * 落地页 / Manager setup 复用同一组件但不打点。
 */
export enum MgmtLendersEvent {
    /**
     * 点 Add lender 打开弹窗。
     * value 与 metadata.type 相同：click_open_popup
     */
    ADD_LENDER_BUTTON = 'LENDERS_ADD_LENDER_BUTTON',
    /** Add lender 后第一次 Save 落库。value 与 metadata.lender_id 相同，如 lender_id-34 */
    INSERT = 'LENDERS_INSERT',
    /** 已有 lender 展开编辑后 Save。value 与 metadata.lender_id 相同，如 lender_id-34 */
    UPDATE = 'LENDERS_UPDATE',
    /** 删除一家 lender。value 与 metadata.lender_id 相同，如 lender_id-34 */
    DELETE = 'LENDERS_DELETE',
    /** Add Promotion 保存 */
    PROMOTION_INSERT = 'LENDERS_PROMOTION_INSERT',
    /** Edit promotion 保存 */
    PROMOTION_UPDATE = 'LENDERS_PROMOTION_UPDATE',
    /** 删除促销 */
    PROMOTION_DELETE = 'LENDERS_PROMOTION_DELETE',
    /** Add an adjustment 保存 */
    ADJUSTMENT_INSERT = 'LENDERS_ADJUSTMENT_INSERT',
    /** Edit an adjustment 保存 */
    ADJUSTMENT_UPDATE = 'LENDERS_ADJUSTMENT_UPDATE',
    /** 删除调整规则 */
    ADJUSTMENT_DELETE = 'LENDERS_ADJUSTMENT_DELETE',
    /** Can't find your lender? → Send request */
    REQUEST = 'LENDERS_REQUEST',
}
